function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.867 0H28v7.934c0 3.21-.277 5.737-.832 7.58-.581 1.868-1.637 3.539-3.17 5.012C22.468 22 20.512 23.158 18.136 24l-2.179-4.579c2.219-.737 3.817-1.763 4.794-3.079.95-1.316 1.453-3.066 1.505-5.25h-5.388V0zM.911 0h11.133v7.934c0 3.237-.277 5.776-.832 7.619-.581 1.842-1.638 3.5-3.17 4.973C6.485 22 4.53 23.158 2.18 24L0 19.421c2.219-.737 3.817-1.763 4.794-3.079.95-1.316 1.453-3.066 1.505-5.25H.911V0z",
  fill: "#1976D2"
});

function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none"
  }, props), _ref);
}

export default SvgQuote;